import React, { useCallback } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { NoStyleButton } from '@daedalus/atlas/helpers/NoStyleButton';
import { Text } from '@daedalus/atlas/Text';
import { TabsContext } from './Tabs';
interface Props {
  value: string;
}
const ActiveUnderline = /*#__PURE__*/styled('span')({
  name: "ActiveUnderline",
  class: "au496wd",
  propsAsIs: false
});

//We can't have 18px margins from theme spacing, needs to be combined 16+2 to match the design (confirmed with @Design)
const AdditionalMargin = /*#__PURE__*/styled('div')({
  name: "AdditionalMargin",
  class: "a3tg1ah",
  propsAsIs: false
});
const TabWrapper = /*#__PURE__*/styled('li')({
  name: "TabWrapper",
  class: "tcczsd9",
  propsAsIs: false
});
const _exp7 = /*#__PURE__*/() => NoStyleButton;
const StyledButton = /*#__PURE__*/styled(_exp7())({
  name: "StyledButton",
  class: "siylx0w",
  propsAsIs: true
});
export const Tab: React.FC<Props> = ({
  value,
  children
}) => {
  const {
    onChange,
    value: activeTab
  } = React.useContext(TabsContext);
  const onClick = useCallback(() => {
    onChange(value);
  }, [onChange, value]);
  const isActive = activeTab === value;
  return <TabWrapper className={cx(isActive && 'isActive')}>
      <ActiveUnderline className={cx(isActive && 'isActive')} />
      <StyledButton onClick={onClick}>
        <AdditionalMargin>
          <Text variant="labelS">{children}</Text>
        </AdditionalMargin>
      </StyledButton>
    </TabWrapper>;
};

require("./Tab.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Tab.tsx");